import { useState } from 'react';

const useMemoizedArray = (initialArray = []) => {
  const [memoizedArray, setMemoizedArray] = useState(initialArray);

  const updateMemoizedArray = (array) => {
    if (!Array.isArray(array)) {
      return;
    }

    const intersect = array.filter(item => memoizedArray.includes(item));

    if (intersect.length === array.length && intersect.length === memoizedArray.length) {
      return;
    }

    setMemoizedArray(array);
  };

  return [memoizedArray, updateMemoizedArray];
};

export default useMemoizedArray;
